import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useRef,
  useContext,
} from "react";
import api from "../api/axios";
import "./Scss/ClientStyles.scss?v=1.1.3";
// Animations
import { Alert, Autocomplete, Fade } from "@mui/material";
// COMPONENTS
import { Grid, TextField } from "@mui/material";
import ReactPaginate from "react-paginate";
// MANUAL COMPONENTS
import Layout from "../Components/Common/Layout";
import Table from "../Components/Common/Table/Table";
// FUNCTIONS
import { CircularProgress, Button } from "@mui/material/";

import "../styles/App.scss?v=1.1.9";

import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
} from "../Components/helpers/Helpers";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import { RenderCell } from "../Components/Common/Table/RenderCell";
import { PersonAdd } from "@mui/icons-material";
import TableActions from "../Components/Common/Table/TableActions";
import { PermissionContext, UserContext } from "../Components/Context/Context";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Unauthorized from "../Components/Common/Design/Unauthorized";

function Clientes(props) {
  const mountedRef = useRef(true);

  // SweetAlert
  const Swal = require("sweetalert2");

  const { userData } = useContext(UserContext);
  const { user } = userData;
  const { can } = useContext(PermissionContext);
  const hasPermission = can("clients", "view");

  const [client, setClient] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [flag, setFlag] = useState(false);
  const [dataNoResults, setDataNoResults] = useState(false);
  const [search, setSearch] = useState(false);

  // Columns data input filters
  const [lawyersData, setLawyersData] = useState({
    name: "",
    surname: "",
    id: 0,
  });
  const [statusId, setStatusId] = useState(0);
  const [company, setCompany] = useState(0);
  const [association, setAssociation] = useState(0);

  const [queryProvinceName, setQueryProvinceName] = useState(false);
  const [queryName, setQueryName] = useState(false);
  const [querySurname, setQuerySurname] = useState(false);
  const [queryPhone, setQueryPhone] = useState(false);
  const [queryEmail, setQueryEmail] = useState(false);
  const [queryObjPerPage, setQueryObjPerPage] = useState(false);

  const [provinceFilter, setProvinceFilter] = useState(0);
  const [nameFilter, setNameFilter] = useState(0);
  const [surnameFilter, setSurnameFilter] = useState(0);
  const [phoneFilter, setPhoneFilter] = useState(0);
  const [emailFilter, setEmailFilter] = useState(0);

  // DATEPICKER
  const [stateColumn, setStateColumn] = useState(0);

  // LISTAS PARA SELECTS FILTERS
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsLawyers, setOptionsLawyers] = useState([]);
  const [optionsCompanies, setOptionsCompanies] = useState([]);
  const [optionsAsociations, setOptionsAsociations] = useState([]);

  const [changeDone, setChangeDone] = useState(false);

  const handlePageClick = (event) => {
    setPagePressed(event.selected + 1);
  };

  const getDataClients = async () => {
    setFlag(true);

    const parametros = {
      page: pagePressed,
      objPerPage,
      status: statusId?.id,
      lawyerName: lawyersData?.name,
      lawyerSurname: lawyersData?.surname,
      companySelected: company?.id,
      asociationSelected: association?.id,
      name: nameFilter,
      surname: surnameFilter,
      phone: phoneFilter,
      email: emailFilter,
      province: provinceFilter,
    };

    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + "/users",
        parametros,
      );
      console.log(response);

      const { status, clients, companies, associations, lawyers } =
        response.data;

      const clientsData = clients.data;
      const clientsCount = clients.total;
      const totalPages = clients.last_page;

      clientsData.forEach((client) => {
        if (client.lawyers_relation.id !== 0) {
          client.lawyers_fullname = `${client.lawyers_relation.name} ${client.lawyers_relation.surname}`;
        }
        if (client.name !== "" || client.surname !== "") {
          client.client_fullname = `${client.name} ${client.surname}`;
        }
      });

      updateOptions(companies, lawyers, associations);

      setPageCount(totalPages);
      setTotalPagesNumber(clientsCount);
      setClient(clientsData);
    } catch (error) {
      console.error(
        "Ha ocurrido un error en la respuesta del servidor:",
        error,
      );
    } finally {
      setFlag(false); // Asegúrate de restablecer el flag en caso de error
    }
  };

  const handleFilterStates = () => {
    setLawyersData({
      name: "",
      surname: "",
    });
    setCompany({ company_name: "Seleccionar", id: 0 });
    setAssociation({ asoc_name: "Seleccionar", id: 0 });
    setStatusId({ nombre: "Seleccionar", id: 0 });

    // MANEJO DE FILTROS
    setQueryName(false);
    setQuerySurname(false);
    setQueryPhone(false);
    setQueryEmail(false);
    setQueryProvinceName(false);

    setProvinceFilter(0);
    setNameFilter(0);
    setSurnameFilter(0);
    setPhoneFilter(0);
    setEmailFilter(0);
    // MANEJO DE FILTROS

    setSearch(!search);
  };

  // Función para actualizar las opciones
  const updateOptions = (companies, lawyers, associations) => {
    companies.unshift({ company_name: "Seleccionar", id: 0 });
    lawyers.unshift({ name: "Seleccionar", surname: "" });
    associations.unshift({ asoc_name: "Seleccionar", id: 0 });

    const arrayToStatus = [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Activo", id: 1 },
      { nombre: "Inactivo", id: -1 },
    ];

    setOptionsLawyers(lawyers);
    setOptionsCompanies(companies);
    setOptionsAsociations(associations);
    setOptionsStatus(arrayToStatus);
  };

  // Initial client table information
  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataClients();
  }, [objPerPage, pagePressed, search, changeDone]);

  useEffect(() => {
    if (typeof queryName == "string") {
      setNameFilter(queryName);
    }
  }, [queryName]);

  useEffect(() => {
    if (typeof querySurname == "string") {
      setSurnameFilter(querySurname);
    }
  }, [querySurname]);

  useEffect(() => {
    if (typeof queryPhone == "string") {
      setPhoneFilter(queryPhone);
    }
  }, [queryPhone]);

  useEffect(() => {
    if (typeof queryEmail == "string") {
      setEmailFilter(queryEmail);
    }
  }, [queryEmail]);

  useEffect(() => {
    if (typeof queryProvinceName == "string") {
      setProvinceFilter(queryProvinceName);
    }
  }, [queryProvinceName]);

  useEffect(() => {
    if (typeof queryObjPerPage == "string") {
      if (totalPagesNumber < queryObjPerPage) {
        setObjPerPage(totalPagesNumber);
      } else {
        setObjPerPage(queryObjPerPage);
      }
    }
  }, [queryObjPerPage]);

  const renderStatus = (value) => {
    const estado = value;
    const estadoMap = {
      0: "Inactivo",
      1: "Activo",
    };
    return (
      <div className="spanClassForTables centerContent">
        {estadoMap[estado] || "Sin asignar"}
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE CLIENTES",
        columns: [
          {
            Header: <span>Abogado</span>,
            accessor: "lawyers_fullname",
            minWidth: 120,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Empresa",
            accessor: "company_relation.company_name",
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Asociación",
            accessor: "asociations_relation.asoc_name",
            minWidth: 170,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Provincia",
            accessor: "province",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Nombre y Apellidos",
            accessor: "client_fullname",
            minWidth: 166,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Teléfono",
            accessor: "phone",
            minWidth: 80,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Email",
            accessor: "email",
            minWidth: 174,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Estado",
            accessor: "status",
            minWidth: 110,
            Cell: ({ value }) => renderStatus(value),
          },
          {
            Header: "Última conexión",
            accessor: "last_login",
            minWidth: 200,
            Cell: ({ value }) => (
              <RenderCell value={value} dateFlag={true} view="clientes" />
            ),
          },
          {
            Header: "Acciones",
            accessor: "id",
            minWidth: 174,
            Cell: ({ value, row }) => (
              <TableActions
                rute={"clientes"}
                apiRute={"users"}
                module={"clients"}
                completeValue={row.original}
                value={value}
                userLogged={user}
                showView
                showEdit
                showDelete
                showTransfer
                textTransfer={"expedientes"}
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );

  // FILTER FIELDS
  const fieldsConfig = [
    {
      type: "autocomplete",
      label: "Abogado:",
      className: "assignToId",
      value: lawyersData,
      options: optionsLawyers,
      getOptionLabel: (option) =>
        option?.name ? `${option.name} ${option.surname || ""}` : "",
      onChange: (event, value) =>
        value
          ? setLawyersData({
              name: value.name,
              surname: value.surname,
              id: value.id,
            })
          : setLawyersData({ name: "Seleccionar", surname: "" }),
      isOptionEqualToValue: (option, value) => option.id === value.id,
    },
    {
      type: "autocomplete",
      label: "Empresa",
      className: "companyId",
      value: company,
      options: optionsCompanies,
      getOptionLabel: (option) => option?.company_name || "",
      onChange: (event, value) => setCompany(value?.id ? value : null),
      isOptionEqualToValue: (option, value) => option.id === value.id,
    },
    {
      type: "autocomplete",
      label: "Asociaciones",
      className: "asociationsId",
      value: association,
      options: optionsAsociations,
      getOptionLabel: (option) => option?.asoc_name || "",
      onChange: (event, value) => setAssociation(value?.id ? value : null),
      isOptionEqualToValue: (option, value) => option.id === value.id,
    },
    {
      type: "autocomplete",
      label: "Estado",
      className: "statusId",
      value: statusId,
      options: optionsStatus,
      getOptionLabel: (option) => option?.nombre || "",
      onChange: (event, value) => setStatusId(value?.id ? value : null),
      isOptionEqualToValue: (option, value) => option?.nombre === value?.nombre,
    },
    {
      type: "text",
      value: queryProvinceName == 0 ? "" : provinceFilter,
      label: "Provincia",
      onChange: (e) => setProvinceFilter(e.target.value),
    },
    {
      type: "text",
      value: queryName == 0 ? "" : nameFilter,
      label: "Nombre cliente",
      onChange: (e) => setQueryName(e.target.value),
    },
    {
      type: "text",
      value: querySurname == 0 ? "" : surnameFilter,
      label: "Apellido cliente",
      onChange: (e) => setQuerySurname(e.target.value),
    },
    {
      type: "text",
      value: queryPhone == 0 ? "" : phoneFilter,
      label: "Teléfono",
      onChange: (e) => setQueryPhone(e.target.value),
    },
    {
      type: "text",
      value: queryEmail == 0 ? "" : emailFilter,
      label: "Email",
      onChange: (e) => setQueryEmail(e.target.value),
    },
  ];

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  const content = (
    <div className="mainContainer">
      <div className="subMainContainer">
        <Grid
          container
          direction="row"
          item
          xs={12}
          className="filtersContainer">
          {fieldsConfig.map((field, index) => (
            <Grid
              item
              xs={4}
              md={2}
              key={index}
              textAlign="left"
              sx={{ padding: "5px" }}>
              {field.type === "autocomplete" ? (
                <Autocomplete
                  className={field.className}
                  size="small"
                  onChange={field.onChange}
                  options={field.options}
                  isOptionEqualToValue={field.isOptionEqualToValue}
                  getOptionLabel={field.getOptionLabel}
                  value={field.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={field.label}
                      autoComplete="off"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <Fragment>
                            {field.loading && (
                              <CircularProgress color="inherit" size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </Fragment>
                        ),
                        form: {
                          autoComplete: "off",
                        },
                      }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                    />
                  )}
                />
              ) : (
                <TextField
                  onChange={field.onChange}
                  label={field.label}
                  value={field.value}
                  variant="outlined"
                  autoComplete="new-password"
                  size="small"
                  fullWidth
                />
              )}
            </Grid>
          ))}
          <Grid
            item
            xs={4}
            md={2}
            textAlign="right"
            sx={{
              padding: "5px",
              position: "relative",
            }}>
            <select
              onChange={(event, value) => {
                setQueryObjPerPage(event.target.value);
              }}
              className="noBorderRadius inputsFont"
              style={{
                width: "100%",
                height: "100%",
              }}
              defaultValue={objPerPage}>
              <option
                style={{ padding: "5px", textAlign: "center" }}
                value={10}>
                {" "}
                10{" "}
              </option>
              <option
                style={{ padding: "5px", textAlign: "center" }}
                value={20}>
                {" "}
                20{" "}
              </option>
              <option
                style={{ padding: "5px", textAlign: "center" }}
                value={30}>
                {" "}
                30{" "}
              </option>
              <option
                style={{ padding: "5px", textAlign: "center" }}
                value={100}>
                100
              </option>
              <option
                style={{ padding: "5px", textAlign: "center" }}
                value={200}>
                200
              </option>
            </select>
            <span
              style={{
                position: "absolute",
                left: "0px",
                backgroundColor: "white",
                top: "0px",
                fontSize: "13px",
              }}>
              Nº Registros
            </span>
          </Grid>
          <Grid item xs={12} md={12} textAlign="center" mt={1}>
            <Button
              onClick={() => setSearch(!search)}
              color="success"
              variant="contained"
              sx={{
                marginRight: "10px",
              }}>
              BUSCAR
            </Button>
            <Button
              onClick={handleFilterStates}
              color="error"
              variant="outlined">
              LIMPIAR FILTROS
            </Button>
          </Grid>
        </Grid>
        <Fade timeout={600} in>
          <div>
            {flag && hasPermission && (
              <LoadingPage isLoading={true} heightProp={"60vh"} />
            )}
            {!flag && (
              <div>
                <Table
                  columns={columns}
                  data={client}
                  view={"cliente"}
                  viewTitle={"clientes"}
                  totalPagesNumber={totalPagesNumber}
                  icon={PersonAdd}
                  viewPermission={"users"}
                  apiRoute={"users"}
                />
                {totalPagesNumber > 10 && (
                  <div className="tablePaginateContainer">
                    <div className="paginatorLeftText">
                      Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                      {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                      {totalPagesNumber} resultados
                    </div>
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel={<ChevronRight size={18} />}
                      previousLabel={<ChevronLeft size={18} />}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={pageCount}
                      containerClassName="pagination"
                      activeClassName="active"
                      pageClassName="page-item"
                      nextClassName="page-item"
                      previousClassName="page-item"
                      disabledClassName="disabled"
                      forcePage={pagePressed - 1} // Esto sincroniza el botón activo
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </Fade>
      </div>
    </div>
  );

  // SEARCH BUTTON
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Clientes" />

      {!hasPermission && <Unauthorized />}

      {hasPermission && content}
    </div>
  );
}

export default Clientes;
